import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useProductRefreshSettingsIa } from 'features/app_shell/product_refresh/useProductRefreshSettingsIa';
const tabContainerIsTabletUpCss = "t1op4a5j";
const tabContainerCss = "tjlt4rg";
export const TabContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isRebrandSettingsIaEnabled = useProductRefreshSettingsIa();
  return <Component ref={ref} {...restProps} className={classNames(tabContainerCss, {
    [tabContainerIsTabletUpCss]: isTabletUp && !isRebrandSettingsIaEnabled
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");